import { cva } from "class-variance-authority"

export const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground hover:bg-primary/90",
        destructive:
          "bg-destructive text-destructive-foreground hover:bg-destructive/90",
        outline:
          "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
        secondary:
          "bg-secondary text-secondary-foreground hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline",
      },
      // Tres densidades, y la misma escalera para el boton con texto y para el
      // de solo icono. No hay una cuarta.
      //
      //   comodo   h-10  una accion que ocupa su sitio: un formulario, un dialogo
      //   compacto h-9   una barra de herramientas
      //   denso    h-8   una fila de una lista, o una celda
      //
      // `xs` y los dos iconos pequenos no existian, y esa era la razon de que
      // 158 botones del repositorio se pusieran la altura a mano en cinco
      // valores distintos -h-6, h-7, h-8, h-9, h-12-: no habia donde elegir.
      // Un tamano que falta no se resuelve en la vista, se anade aqui.
      size: {
        default: "h-10 px-4 py-2",
        sm: "h-9 rounded-md px-3",
        xs: "h-8 rounded-md px-2.5 text-xs",
        lg: "h-11 rounded-md px-8",
        icon: "h-10 w-10",
        "icon-sm": "h-9 w-9",
        "icon-xs": "h-8 w-8",
        // Un boton que ES una tarjeta: una opcion que se elige y que dentro
        // lleva su icono, su nombre y su descripcion. No cabe en ninguna
        // altura, porque su altura la decide lo que lleva dentro. Aparecio al
        // convertir el selector de herramientas de Agent Studio, y la regla
        // dice que un tamano que falta se anade aqui, no en la vista.
        tarjeta: "h-auto w-full flex-col items-stretch justify-start rounded-lg p-4 text-left",
        // One option per line: a row of text that is chosen, as long as the
        // text needs -- the Brain's question card, where an option can be a
        // whole sentence and a fixed height would cut it.
        fila: "h-auto w-full items-start justify-start gap-2 whitespace-normal px-3 py-2 text-left font-normal",
        // El menu, y solo el menu. Es la unica superficie que se toca con el
        // dedo tanto como con el raton, y las dos medidas son distintas: 44px
        // es el objetivo tactil que pide la accesibilidad, y 32px lo que cabe
        // en una barra lateral de escritorio.
        //
        // Estaba escrito a mano en `nav.tsx` seis veces -`h-11 w-11 md:h-8
        // md:w-8`, `h-11 md:h-8`, `h-9 md:h-7`-, que es justo lo que la regla
        // del tamano prohibe. Un tamano que falta se anade aqui.
        nav: "h-11 px-3 md:h-8",
        "nav-sm": "h-9 px-3 text-xs md:h-7",
        "icon-nav": "h-11 w-11 md:h-8 md:w-8",
      },
    },
    // Un enlace no tiene caja: no ocupa alto ni lleva relleno, porque va dentro
    // de una frase o pegado a otro texto. Sin esto, cada sitio que usaba
    // `variant="link"` se escribia `h-auto p-0` a mano -y eso es exactamente lo
    // que la regla del tamano prohibe-. La excepcion de una variante se declara
    // en la variante.
    compoundVariants: [
      // Un enlace toma el tamano del texto que lo rodea, que es como funciona
      // un enlace: dentro de un titulo se ve como el titulo.
      { variant: "link", class: "h-auto p-0 text-[length:inherit]" },
    ],
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)
